import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from 'components/ui/use-toast';
import * as Api from '../api';
import * as Types from '../types';

interface UpdateData extends Types.IApi.Update.Request {
  id: string;
}

const useUpdate = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async ({ id, ...data }: UpdateData) => {
      const response = await Api.update(id, data);
      return response.data.data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['notebooks'] });
      queryClient.invalidateQueries({ queryKey: ['notebooks', variables.id] });
      toast.success(t('notebooks.updated'));
    },
    onError: (error: any) => {
      toast.error(t('notebooks.update_failed'), { description: error?.response?.data?.message });
    },
  });
};

export default useUpdate;
